export const PROGRAM_CONSTANTS = {
    MIN_HIGHEST_PRODUCT_PRICE: 5000,
    DECIMAL_REGEX: /^\d*(\.\d{0,2})?$/,
    SUBSIDY_TYPES: {
        SELECT_SUBSIDY_TYPE: '',
        TOTAL_VALUE: 'total-value',
        PERCENTAGE_SUBSIDY: 'percentage-subsidy',
    },
    DISCOUNT_TYPES: {
        SELECT_DISCOUNT_TYPE: '',
        NONE: 'none',
        PERCENTAGE: 'percentage',
        FIXED_AMOUNT: 'fixed',
    },
    REQUIRED_FIELDS: {
        FIRST_NAME: 'first-name',
        LAST_NAME: 'last-name',
        EMPLOYEE_ID: 'employee-id',
        PO_NUMBER: 'po-number',
    },
    SORT_OPTIONS: [
        { label: 'Product', value: 'product asc', directionLabel: 'A-Z' },
        { label: 'Product', value: 'product desc', directionLabel: 'Z-A' },
        { label: 'SKU', value: 'sku asc', directionLabel: 'A-Z' },
        { label: 'SKU', value: 'sku desc', directionLabel: 'Z-A' },
        { label: 'Price', value: 'price asc', directionLabel: 'Low-High' },
        { label: 'Price', value: 'price desc', directionLabel: 'High-Low' },
        { label: 'Price Override', value: 'override asc', directionLabel: 'Off-On' },
        { label: 'Price Override', value: 'override desc', directionLabel: 'On-Off' },
        { label: 'Exclude', value: 'exclude asc', directionLabel: 'Not Excluded-Excluded' },
        { label: 'Exclude', value: 'exclude desc', directionLabel: 'Excluded-Not Excluded' },
    ],
    PROGRAMS_SORT_OPTIONS: [
        { label: 'Program Name', value: 'programName asc', directionLabel: 'Ascending' },
        { label: 'Program Name', value: 'programName desc', directionLabel: 'Descending' },
        { label: 'Customer', value: 'customer asc', directionLabel: 'A-Z' },
        { label: 'Customer', value: 'customer desc', directionLabel: 'Z-A' },
        { label: 'Status', value: 'status asc', directionLabel: 'Ascending' },
        { label: 'Status', value: 'status desc', directionLabel: 'Descending' },
        { label: 'Date Created', value: 'dateCreated asc', directionLabel: 'A-Z' },
        { label: 'Date Created', value: 'dateCreated desc', directionLabel: 'Z-A' },
    ],
    DEFAULTS: {
        DISCOUNT_AMOUNT: 0,
        MAX_ITEMS: 0,
        MAX_VALUE: 0,
        MAX_USE: 0,
        NOTIFICATION_THRESHOLD: 0,
    },
    RESOURCE_NAME: {
        singular: 'program',
        plural: 'programs',
    },
    RESOURCE_PRODUCT_NAME: {
        singular: 'product',
        plural: 'products',
    },
    FILTER_DEBOUNCE_DELAY: 500,
};
